// extracted by mini-css-extract-plugin
export default {"tableHead":"ScenarioList_tableHead__UYCMR","tableBodyRow":"ScenarioList_tableBodyRow__9WQzM"};